/**
 * "Unsaved changes" / "All changes saved" next to a form's Save button.
 *
 * Settings forms disable Save until something changes and again after a save.
 * A greyed button on its own read as stuck (client issue I-5), so this says
 * which of the two it is. Announced politely to screen readers as it flips.
 */
export function SaveStatus({ dirty }: { dirty: boolean }) {
  return (
    <span role="status" aria-live="polite" className="inline-flex items-center">
      {dirty ? (
        <span className="inline-flex items-center gap-1.5 rounded-full bg-warning-100 dark:bg-warning-900/40 px-2.5 py-1 text-xs font-semibold text-warning-700 dark:text-warning-300 transition-all duration-200">
          <span className="h-1.5 w-1.5 rounded-full bg-warning-500 animate-pulse" aria-hidden="true" />
          Unsaved changes
        </span>
      ) : (
        <span className="inline-flex items-center gap-1 text-xs font-medium text-success-600 dark:text-success-400 transition-all duration-200">
          <svg className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5} aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
          </svg>
          All changes saved
        </span>
      )}
    </span>
  );
}
